import { render, staticRenderFns } from "./back-render.vue?vue&type=template&id=2bf7cb18&scoped=true&"
import script from "./back-render.vue?vue&type=script&lang=ts&"
export * from "./back-render.vue?vue&type=script&lang=ts&"
import style0 from "./back-render.vue?vue&type=style&index=0&id=2bf7cb18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf7cb18",
  null
  
)

export default component.exports